import { FormFieldType, UploadFormField } from "../types";
import {
  Box,
  FileUpload,
  FileUploadProps,
  SpaceBetween,
  Spinner,
} from "@amzn/awsui-components-console";
import { transformSerializedFilesToFiles } from "../FileUpload/FileUploadUtilities";

const renderFileUpload = (
  field: FormFieldType,
  onFileUpload: (
    { detail }: { detail: FileUploadProps.ChangeDetail },
    field: FormFieldType
  ) => void,
  uploadingFile: string
) => {
  const name = field.config.uniqueName || field.config.name;
  const fieldConfig = field.config as UploadFormField;

  return (
    <div>
      <FileUpload
        onChange={(e: { detail: FileUploadProps.ChangeDetail }) => onFileUpload(e, field)}
        value={transformSerializedFilesToFiles(field.state.value)}
        i18nStrings={{
          uploadButtonText: (multiple: boolean) => (multiple ? "Choose files" : "Choose file"),
          dropzoneText: (multiple: boolean) =>
            multiple ? "Drop files to upload" : "Drop file to upload",
          removeFileAriaLabel: (fileIndex: number) => `Remove file ${fileIndex + 1}`,
          limitShowFewer: "Show fewer files",
          limitShowMore: "Show more files",
          errorIconAriaLabel: "Error",
        }}
        multiple={fieldConfig.multiple}
        accept={fieldConfig.accept}
        showFileLastModified
        showFileSize
        tokenLimit={100}
        data-testid={fieldConfig.uniqueName || fieldConfig.name}
        key={`${name}-fileUpload`}
        controlId={fieldConfig.name}
      />
      {uploadingFile === fieldConfig.name ? (
        <SpaceBetween direction="horizontal" size="xs">
          <Spinner variant="disabled" />
          <Box color="text-body-secondary" fontSize="body-m">
            Uploading, please wait...
          </Box>
        </SpaceBetween>
      ) : null}
    </div>
  );
};

export default renderFileUpload;
